import React from 'react';
import PropTypes from 'prop-types';

const isTaxBenefitLimited = (summary) => {
    const { credits, reductions } = summary;
    const total = credits + reductions;

    return credits > 10000 || reductions > 10000 || total > 10000;
};

const TaxBenefitLimitMessage = ({ summary }) => (
    isTaxBenefitLimited(summary) && (
        <div className="messagePlafonnement" style={{ color: '#737373', fontSize: '14px', marginBottom: '15px' }}>
            L&apos;ensemble des réductions et crédits d&apos;impôt soumis au plafonnement des niches fiscales ont été plafonnés à 10 000€.
        </div>
    )
);

TaxBenefitLimitMessage.propTypes = {
    summary: PropTypes.shape({
        credits: PropTypes.number.isRequired,
        reductions: PropTypes.number.isRequired,
    }).isRequired,
};

export default TaxBenefitLimitMessage;
